import React from "react";
import PaymentDetails from "modules/merchantPaymentMethods/components/PaymentDetails";

const MerchantPaymentMethodsDetailsPage = () => {
  return <PaymentDetails />;
};

export default MerchantPaymentMethodsDetailsPage;
